import { render, staticRenderFns } from "./HeaderComponent.vue?vue&type=template&id=55f5a47e&scoped=true"
import script from "./HeaderComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./HeaderComponent.vue?vue&type=style&index=0&id=55f5a47e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f5a47e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55f5a47e')) {
      api.createRecord('55f5a47e', component.options)
    } else {
      api.reload('55f5a47e', component.options)
    }
    module.hot.accept("./HeaderComponent.vue?vue&type=template&id=55f5a47e&scoped=true", function () {
      api.rerender('55f5a47e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Header/HeaderComponent.vue"
export default component.exports